import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-shirt',
	templateUrl: './icon-shirt.component.svg',
})
export class IconShirtComponent {}
